/**
 * changelog-modal.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { Http, Response } from "@angular/http";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { ChangeItem, Changelog, semverString, VersionAnnotation }
  from "app/configuration/changelog";

interface Version {
  label : string;
  date : Date;
  description : string;
  changes : ChangeItem[];
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Advocus Changelog
    </h4>
  </div>
  <div class="modal-body">
    <p>
      This page shows recent changes to Advocus. For older changes, visit the <a href="/zone/documents/changelog_archive.html" target="_blank">archive <span class="glyphicon glyphicon-share"></span></a>.
    </p>
    <label>Filter:</label>
    <button class="btn" [class.btn-primary]="category === null" [class.btn-default]="category !== null" (click)="category = null">All</button>
    <button *ngFor="let cat of categoryOptions" class="btn" [class.btn-primary]="category === cat" [class.btn-default]="category !== cat" (click)="category = cat">{{cat}}</button>
    <hr />
    <div *ngFor="let version of versions">
      <h3>
        {{version.label}}
        <small class="date">{{version.date | date}}</small>
      </h3>
      <p *ngIf="version.description">
        <em>{{version.description}}</em>
      </p>
      <ul>
        <template ngFor let-change [ngForOf]="version.changes">
          <li *ngIf="matches(change.category)">
            <kbd [class]="change.category">
              {{change.category}}
            </kbd>
            {{change.description}}
            <kbd class="tag" *ngFor="let tag of change.tags">{{tag}}</kbd>
          </li>
        </template>
      </ul>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.close()">
      Close
    </button>
  </div>
  `,
  styles: [
    `
    .tag {
      opacity: 0.5;
    }
    .date {
      float: right;
    }
    kbd.core {
      color: darkgoldenrod;
    }
    kbd.rules {
      color: darkblue;
    }
    `
  ]
})
export class ChangelogModalComponent implements ModalComponent<any>
{
  public readonly categoryOptions : string[] = ["core", "rules"];

  public category : string | null;
  public matches (cat : string) : boolean
  {
    return this.category === null || this.category === cat;
  }

  public changesByVersion : Map<string, ChangeItem[]> = new Map();
  private versionsWithoutAnnotations : Set<string>;
  public versions : Version[] = [];

  public constructor (
    public dialog : DialogRef<any>,
    private http : Http
  )
  {
    this.load();
  }

  public load () : void
  {
    this.changesByVersion.clear();
    this.versionsWithoutAnnotations = new Set();
    this.category = null;
    this.http.get("/zone/documents/changelog.json").subscribe(
      (r : Response) => {
        const changelog : Changelog = r.json();
        changelog.changes.forEach((change : ChangeItem) => {
          const version : string = semverString(change.version);
          this.versionsWithoutAnnotations.add(version);
          if (!this.changesByVersion.has(version))
          {
            this.changesByVersion.set(version, [change]);
          }
          else
          {
            this.changesByVersion.get(version).push(change);
          }
        });

        this.versions = changelog.versions.map(
          (v : VersionAnnotation) => {
            const vName : string = semverString(v.version);
            this.versionsWithoutAnnotations.delete(vName);
            return {
              label: v.displayName || vName,
              date: new Date(v.date),
              description: v.description || "",
              changes: this.changesByVersion.get(vName) || []
            };
        });

        this.versionsWithoutAnnotations.forEach((vName : string) => {
          this.versions.push({
            label: `Unassigned [${vName}]`,
            date: new Date(0),
            description: "No description available!",
            changes: this.changesByVersion.get(vName)
          });
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/changelog-modal.component.ts